export default __webpack_public_path__ + "static/media/white_plus.c2635a15.svg";